import i18next from "i18next";
import React, { useMemo } from "react";
import CloseIcon from "../../Icons/CloseIcon";
import Headline from "../../Typography/Headline";
import { OverlayProps } from "../type";
import { getTotalEnergy } from "~/assets/js/Helpers/util";
import { convertUnit } from "~/assets/js/Format";

const IngredientsOverlay = ({
    ingredients,
    onClose,
    open,
    productName,
    customClass = "",
    envDetails,
    url,
}) => {
    if (!open) {
        return null;
    }

    const formattedEnvDetails = useMemo(() => {
        const attributes = Object.values(envDetails);
        if (attributes.includes(undefined)) {
            return undefined;
        }

        const formatted = {
            details: envDetails,
        };

        return {
            kcal: Math.floor(getTotalEnergy(formatted)),
            co2: convertUnit(envDetails.co2, 0.001), // g -> kg
        };
    }, [envDetails]);

    const closeOverlay = (e) => {
        e.preventDefault();
        onClose();
    };

    return (
        <a href={url}>
            <div className={`ingredients-overlay ${customClass}`}>
                <div className="ingredients-overlay__wrapper">
                    {onClose && (
                        <CloseIcon
                            onClick={closeOverlay}
                            customClass="ingredients-overlay__close"
                            iconSize={24}
                        />
                    )}
                    {productName && (
                        <span className="ingredients-overlay__product-name">
                            {productName}
                        </span>
                    )}
                    <Headline size={4} className="ingredients-overlay__title">
                        {i18next.t("complementary.ingredients")}
                    </Headline>
                    <ul className="ingredients-overlay__ingredients-list">
                        {ingredients.map((ingr) => (
                            <li key={`ingredient-${ingr.name}`}>{ingr.name}</li>
                        ))}
                    </ul>
                    {!!formattedEnvDetails && (
                        <div className="ingredients-overlay__meta-attr">
                            <div className="ingredients-overlay__meta-attr-item">
                                <img
                                    src={`${reactConfig.iconPath}/cutlery-new.svg`}
                                    alt="kcal-icon"
                                />
                                <div className="ingredients-overlay__meta-attr-item-info">
                                    <div>
                                        {i18next.t(
                                            "nutrients.names.caloricValue"
                                        )}
                                    </div>
                                    <span>{formattedEnvDetails.kcal} kcal</span>
                                </div>
                            </div>
                            <div className="ingredients-overlay__meta-attr-item">
                                <img
                                    src={`${reactConfig.iconPath}/globe.svg`}
                                    alt="co2-icon"
                                />
                                <div className="ingredients-overlay__meta-attr-item-info">
                                    <CO2 />
                                    <span>{formattedEnvDetails.co2} Kg</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </a>
    );
};

const CO2 = () => (
    <div>
        CO<sup>2</sup>
    </div>
);

IngredientsOverlay.propTypes = OverlayProps;
export default IngredientsOverlay;
